export default [
  {
    title: 'breadcrumb.agent',
    route: 'list-agent',
    icon: '',
    resource: 'agent',
    action: 'read'
  }
];